// =============================================================================
// sons.js : la façade des sons de confirmation (décision n° 10). Seule partie
// du bundle principal ; le moteur (src/sonsMoteur.js) se charge À LA DEMANDE.
// Réglage éteint (le défaut) : ni contexte audio, ni écoute des gestes ; le
// moteur (2,4 ko gzip) n'est préchargé qu'à l'ouverture de « Moi » ou de la
// palette, pour que l'aperçu parte dans le geste qui active le réglage.
//
// Un son CONFIRME un acte : toast.success() le demande avec son texte (le
// moteur tait copie, téléchargement, aperçu, « rien à faire », succès partiel ;
// { son: false } l'en exclut) ; les pages à jeton sans toast l'appellent à leur
// écran de confirmation (présence, émargement, repas). Jamais pour une erreur.
// En salle, silence : la console de séance et le plein écran de séance posent
// <html data-salle> (entrerEnSalle) ; l'écran de salle, Thémis (vue screen) ou
// vote d'AG (/vote/<code>/ecran), où qu'il soit ouvert dans le navigateur
// (fenêtre à part sur le vidéoprojecteur, onglet), bat en localStorage
// (signalerEcranSalle) : tous les onglets se taisent tant qu'il bat.
// =============================================================================
import { sonsActifs } from "./preferencesCoquille";

let moteur = null;
let chargement = null;
const charger = () => chargement || (chargement = import("./sonsMoteur")
  .then((m) => (moteur = m))
  .catch(() => { chargement = null; return null; }));

/** Charge le moteur sans rien jouer. Sans argument, seulement si le réglage
 *  est actif (démarrage d'App, pages à jeton) : les gestes sont écoutés dès
 *  les premiers clics, ce qui déverrouille l'audio d'iOS. `toujours` : à
 *  l'ouverture de « Moi », pour que l'aperçu parte DANS le geste. */
export function prechargerSons(toujours) {
  if (toujours || sonsActifs()) charger().then((m) => { if (m && sonsActifs()) m.installer(); });
}

/** Son de confirmation : muet si le réglage est éteint ou l'onglet caché. */
export function jouerSon(nom, opts) {
  if (!sonsActifs() || (typeof document !== "undefined" && document.hidden)) return;
  if (moteur) moteur.jouer(nom, opts); else charger().then((m) => m && sonsActifs() && m.jouer(nom, opts));
}

let salles = 0;
/** L'écran est partagé ou projeté tant que l'appelant est monté : aucun son.
 *  Rend la fonction de sortie (à rendre telle quelle par un useEffect). */
export function entrerEnSalle() {
  const h = typeof document !== "undefined" && document.documentElement;
  if (!h) return () => {};
  salles += 1;
  h.setAttribute("data-salle", "");
  let sorti = false;
  return () => {
    if (sorti) return;
    sorti = true;
    salles -= 1;
    if (!salles) h.removeAttribute("data-salle");
  };
}

/** Clé du battement de l'écran de salle (lue par sonsMoteur.enSalle). */
export const CLE_ECRAN_SALLE = "aramis_ecran_salle";

/** Vue « screen » montée (souvent une fenêtre à part, sur le vidéoprojecteur,
 *  quel que soit le bouton qui l'a ouverte) : un battement toutes les 4 s en
 *  localStorage, partagé par les onglets du navigateur ; aucun son tant qu'il
 *  a moins de 10 s. Rend la fonction de sortie (pour un useEffect). */
export function signalerEcranSalle() {
  let dernier = "";
  const battre = () => { dernier = String(Date.now()); try { localStorage.setItem(CLE_ECRAN_SALLE, dernier); } catch { /* stockage bloqué */ } };
  battre();
  const t = setInterval(battre, 4000);
  // À la sortie, on n'efface que NOTRE battement : un autre écran de salle
  // encore ouvert (Thémis et vote d'AG, deux fenêtres) garde le silence.
  return () => {
    clearInterval(t);
    try { if (localStorage.getItem(CLE_ECRAN_SALLE) === dernier) localStorage.removeItem(CLE_ECRAN_SALLE); } catch { /* idem */ }
  };
}

/** Le réglage vient de changer, par un geste (« Moi », palette) : aperçu à
 *  l'activation, joué dans le geste ; extinction sinon. */
export function sonsBascules(actifs) {
  const agir = (m) => { if (!m) return; if (actifs) m.jouer("confirmation", { apercu: true }); else m.eteindre(); };
  if (moteur) agir(moteur); else if (actifs) charger().then(agir);
}
